var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9707 9.59307L23.2281 10.0975C25.0574 10.273 25.6184 12.0599 24.2058 13.2339L20.0899 16.6547L21.6179 22.2274C22.1197 24.0575 20.5629 25.1654 19.0036 24.064L14.0024 20.5314L9.00127 24.064C7.44828 25.1609 5.8851 24.0578 6.38696 22.2274L7.91494 16.6547L3.799 13.2339C2.38049 12.055 2.93931 10.2738 4.77648 10.0975L10.0329 9.59307L12.3487 4.25372C13.074 2.58165 14.9313 2.58248 15.6559 4.25389L17.9707 9.59307Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.a76f12540e53aab370530b5be900eb11.svg";
export { ForwardRef as ReactComponent };